import { render, staticRenderFns } from "./HmnBossApprovalSCRUD.vue?vue&type=template&id=35a1de0f&scoped=true"
import script from "./HmnBossApprovalSCRUD.vue?vue&type=script&lang=js"
export * from "./HmnBossApprovalSCRUD.vue?vue&type=script&lang=js"
import style0 from "./HmnBossApprovalSCRUD.vue?vue&type=style&index=0&id=35a1de0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1de0f",
  null
  
)

export default component.exports